<template>
  <div class="event d-flex flex-column align-items-start">
    <h4>{{this.event_data.title}}</h4>
    <div class="icon-info">
      <div class="event-date">
        <span class="icon">
          <font-awesome icon="calendar" fixed-width />
        </span>
        <span class="info">{{this.event_data.date_begin}}</span>
        <span v-if="this.event_data.date_end != null" class="info">- {{this.event_data.date_end}}</span>
      </div>

      <div class="event-location">
        <span class="icon">
          <font-awesome icon="map-pin" fixed-width />
        </span>
        <span class="info">{{this.event_data.location}}</span>
      </div>
    </div>

    <p>{{this.event_data.summary}}</p>

    <router-link :to="this.path">
      <b-button variant="primary">Read More</b-button>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "Event",
  props: ["event_data"],
  data() {
    return {
      path: `events/${this.event_data.id}`
    };
  }
};
</script>

<style lang="scss">
.event {
  margin-bottom: 4em;

  .icon-info {
    .event-date,
    .event-location {
      margin-top: 0.7em;
    }

    .icon {
      margin-right: 0.7em;

      * {
        color: $secondary-color;
      }
    }

    .info {
      text-transform: uppercase;
    }
  }

  p {
    margin: 1em 0 1em 0;
    text-align: justify;
  }
}
</style>